import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import Lottie from 'react-lottie';
import { Colors, MediaBreakPointUp } from '../styles';
import * as animationData from '../../lotties/2fight.json';
export const GoalMatchingAssessmentResultFinish = ({ lesson, userName, classObject }) => {
    const animationOptions = {
        loop: true,
        animationData: animationData,
    };
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("div", { className: css(styles.title) },
            userName,
            "\u3055\u3093\u306E\u56DE\u7B54\u3092\u3082\u3068\u306B\u3001AI\u304C\u6700\u9069\u306A\u30EC\u30C3\u30B9\u30F3\u3092\u9078\u3073\u307E\u3057\u305F\u2728"),
        React.createElement("img", { className: css(styles.lessonImg), src: lesson.thumbnailURL }),
        React.createElement("div", { className: css(styles.messageRow) },
            React.createElement("div", { className: css(styles.messageCharacter) },
                React.createElement(Lottie, { options: animationOptions, height: 79, width: 80 })),
            React.createElement("div", { className: css(styles.messageBubble) }, "\u3055\u3063\u305D\u304F\u4ECA\u65E5\u304B\u3089\u306F\u3058\u3081\u3066\u307F\u3088\u3046\uFF01"))));
};
const styles = StyleSheet.create({
    container: {},
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 1.28,
        padding: '10px 16px',
        textAlign: 'center',
    },
    lessonImg: {
        display: 'block',
        margin: '32px auto 20px',
        width: '100%',
        borderRadius: 14,
        boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.15)',
        [MediaBreakPointUp.MD]: {
            maxWidth: 327,
            maxHeight: 184,
        },
    },
    messageRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
    },
    messageCharacter: {
        width: 80,
        height: 79,
    },
    messageBubble: {
        fontSize: 16,
        lineHeight: '140%',
        letterSpacing: 0.24,
        backgroundColor: Colors.White,
        borderRadius: 12,
        padding: '8px 12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        maxWidth: 220,
    },
});
